import { useSelector } from 'react-redux';
import { AnnotationAction } from '../../../../redux/modules/annotation/helpers';
import { userRoleNameSelector } from '../../../../redux/modules/user/selectors';
import { GroupRole } from '../../../../types/group';
import { labelsFeatureSelector } from '../../../pricing/selectors';

const allActions: AnnotationAction[] = [
  'delete',
  'export',
  'label',
  'move',
  'moveToReview',
  'postpone',
  'purge',
  'reAutomate',
  'reExtract',
  'reprocess',
  'reprocessConfirmed',
  'upload',
  'validate',
  'addAttachment',
  'createRelation',
  'toggleTraining',
  'documentHistory',
];

const viewerActions: AnnotationAction[] = ['export', 'documentHistory'];

const permittedActions: Record<GroupRole, AnnotationAction[]> = {
  viewer: viewerActions,
  annotator_limited: [
    'delete',
    'label',
    'move',
    'moveToReview',
    'postpone',
    'purge',
    'reAutomate',
    'reExtract',
    'reprocess',
    'reprocessConfirmed',
    'upload',
    'validate',
    'documentHistory',
  ],
  annotator_embedded: [
    'delete',
    'label',
    'move',
    'moveToReview',
    'postpone',
    'purge',
    'reAutomate',
    'reExtract',
    'reprocess',
    'reprocessConfirmed',
    'upload',
    'validate',
    'documentHistory',
  ],
  annotator: allActions.filter(
    action => action !== 'purge' && action !== 'toggleTraining'
  ),
  approver: viewerActions,
  manager: allActions,
  empowered_manager: allActions,
  admin: allActions,
  organization_group_admin: allActions,
};

export const usePermittedActions = () => {
  const userRole = useSelector(userRoleNameSelector);
  const isLabelsEnabled = useSelector(labelsFeatureSelector);

  return {
    // userRole can be undefined before groups are loaded thus fallback to an empty array
    permittedActions: permittedActions[userRole] ?? [],
    isLabelsEnabled,
  };
};
